<template>
  <div>
    <van-nav-bar
      title="移动端(数据均为mock)"
      left-arrow
      @click-left="$router.back()"
    />
    <van-list>
      <van-cell v-for="item of list"
        :key="item.title"
        :title="item.title"
        @click="$router.push(item.path)" />
    </van-list>
  </div>
</template>

<script>
import { NavBar, List, Cell } from 'vant'
import { pages } from '@/common/config'

export default {
  name: 'Home',
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [NavBar.name]: NavBar
  },
  computed: {
    list() {
      return pages.map(item => {
        return { title: item.text, path: item.value }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
